<!-- @veltra/icons generated sha256:a54440c33440ce34 gen:8 source:src/svg/normal/list.svg -->
<script setup lang="ts">
defineOptions({ name: 'List' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M13.504 3H5.496A.484.484 0 0 0 5 3.485v.011A.5.5 0 0 0 5.496 4h8.008A.484.484 0 0 0 14 3.515v-.011A.5.5 0 0 0 13.504 3M2.994 3h-.487A.51.51 0 0 0 2 3.504c0 .268.23.496.507.496h.487a.493.493 0 0 0 .506-.485v-.011A.51.51 0 0 0 2.994 3m2.502 4.5h8.008a.5.5 0 0 1 .496.504v.011c0 .276-.22.485-.496.485H5.496A.5.5 0 0 1 5 7.996v-.01c0-.277.22-.486.496-.486m-2.99 0h.488c.276 0 .506.228.506.504 0 .268-.23.496-.506.496h-.487A.493.493 0 0 1 2 8.015v-.011c0-.276.23-.504.507-.504m2.99 4.5h8.007a.5.5 0 0 1 .496.504v.011c0 .276-.22.485-.496.485H5.496A.5.5 0 0 1 5 12.496v-.011c0-.276.22-.485.496-.485m-2.99 0h.488c.276 0 .506.228.506.504 0 .268-.23.496-.506.496h-.487A.493.493 0 0 1 2 12.515v-.011c0-.276.23-.504.507-.504"
    />
  </svg>
</template>
